<div class="label row">
  {{ label }}
  <span class="beforeCounterExt" #beforecounterext></span>
  <div class="counter">{{ allNames.length }}</div>
</div>
<div class="listBox row">
  <input (keyup)="onKeydownEvent()" [(ngModel)]="filterFor" placeholder="Type to Filter" />
  @if (isLoading) {
    <span class="spinner"></span>
  }

  <div class="text row">
    @for (name of names; track name) {
      <div
        #nameList
        (click)="selected(name)"
        [ngClass]="{ clickable: clickable }"
        class="listText"
        >
        {{ name }}
      </div>
    }
  </div>
</div>
